module.exports = __webpack_public_path__ + "media/creativeMedia/panel04Landscape-255f53f1.png";